<template>
    <footer id="footerApp" class="bg-white dark:bg-jacarta-900 border-t border-gray-100 dark:border-jacarta-800 pb-20 md:pb-0">
        <div class="max-w-7xl mx-auto px-4 py-12">
            <div class="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">

                <!-- Logo + contato -->
                <div>
                    <NuxtLink to="/" class="inline-block mb-5">
                        <img loading="lazy" src='~/assets/logo_dark1.png' class="block max-h-8 dark:hidden" alt="Ticket Smile" />
                        <img loading="lazy" src='~/assets/logo_white.png' class="hidden max-h-8 dark:block" alt="Ticket Smile" />
                    </NuxtLink>
                    <p class="text-sm text-gray-500 dark:text-jacarta-300 mb-4">Poços de Caldas - MG</p>
                    <ul class="text-sm text-gray-500 dark:text-jacarta-300 space-y-1">
                        <li>(11) 5199-6588</li>
                        <li>
                            <NuxtLink to="mailto:contato@ticketsmile.com.br" class="hover:text-pink-600 transition-colors">
                                contato@ticketsmile.com.br
                            </NuxtLink>
                        </li>
                    </ul>
                    <div class="mt-4">
                        <RedesSociais />
                    </div>
                </div>

                <!-- Para participantes -->
                <div>
                    <h3 class="text-sm font-semibold text-jacarta-700 dark:text-white mb-4">Para participantes</h3>
                    <ul class="space-y-2 text-sm text-gray-500 dark:text-jacarta-300">
                        <li><NuxtLink to="/eventos" class="hover:text-pink-600 transition-colors">Explorar eventos</NuxtLink></li>
                        <li><NuxtLink to="/perfil/ingressos" class="hover:text-pink-600 transition-colors">Meus ingressos</NuxtLink></li>
                        <li><NuxtLink to="/perfil/pedidos" class="hover:text-pink-600 transition-colors">Meus pedidos</NuxtLink></li>
                        <li><NuxtLink to="/login" class="hover:text-pink-600 transition-colors">Entrar / Cadastrar</NuxtLink></li>
                    </ul>
                </div>

                <!-- Para organizadores -->
                <div>
                    <h3 class="text-sm font-semibold text-jacarta-700 dark:text-white mb-4">Para organizadores</h3>
                    <ul class="space-y-2 text-sm text-gray-500 dark:text-jacarta-300">
                        <li><NuxtLink to="/painel" class="hover:text-pink-600 transition-colors">Criar evento</NuxtLink></li>
                        <li><NuxtLink to="/painel" class="hover:text-pink-600 transition-colors">Gerenciar eventos</NuxtLink></li>
                        <li><NuxtLink to="/contato" class="hover:text-pink-600 transition-colors">Falar com suporte</NuxtLink></li>
                    </ul>
                </div>

                <!-- Institucional -->
                <div>
                    <h3 class="text-sm font-semibold text-jacarta-700 dark:text-white mb-4">Ticket Smile</h3>
                    <ul class="space-y-2 text-sm text-gray-500 dark:text-jacarta-300">
                        <li><NuxtLink to="/contato" class="hover:text-pink-600 transition-colors">Contato</NuxtLink></li>
                        <li><NuxtLink to="/termos-e-condicoes" target="_blank" class="hover:text-pink-600 transition-colors">Termos e condições</NuxtLink></li>
                        <li><NuxtLink to="/politicas-de-privacidade" target="_blank" class="hover:text-pink-600 transition-colors">Política de privacidade</NuxtLink></li>
                    </ul>
                </div>

            </div>

            <!-- Rodapé inferior -->
            <div class="mt-10 pt-6 border-t border-gray-100 dark:border-jacarta-800 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p class="text-xs text-gray-400">
                    &copy; {{ new Date().getFullYear() }} Ticket Smile Comercio Virtual LTDA — 50.516.107/0001-65
                </p>
                <div class="flex gap-4 text-xs text-gray-400">
                    <NuxtLink to="/termos-e-condicoes" target="_blank" class="hover:text-pink-600 transition-colors">Termos</NuxtLink>
                    <NuxtLink to="/politicas-de-privacidade" target="_blank" class="hover:text-pink-600 transition-colors">Privacidade</NuxtLink>
                </div>
            </div>
        </div>
    </footer>
</template>
